import { FC, useEffect, useState } from 'react';
import { Button, ButtonToolbar, ListGroup, ListGroupItem } from 'reactstrap';
import { NotificationItem } from './NotificationItem';
import NotificationModalWindow from './NotificationModalWindow';
import { EntEventsLogType } from 'src/Types';
import API from 'src/API';

interface INotificationHistoryProps {};

/** Выводит список уведомлений */
export const NotificationHistory: FC<INotificationHistoryProps> = ( props ) => {

	const [ notifications, setNotifications ] = useState<EntEventsLogType[]>([]);
	const [ currentNotification, setCurrentNotification ] = useState<EntEventsLogType>();

	useEffect( () => getNotifications(), [] );

	const getNotifications = () => {
		API.getLogs()
			.then( result => setNotifications( !!result ? result : [] ) )
	};

	const handleDismiss = ( recid: string ) => {
		API.hideLog( recid )
			.then( result => {
				if ( result ) {
					getNotifications();
				}
			})
	};

	return (
		<>
			<ListGroup className="list-group-accent" tag={'div'}>

				<ListGroupItem className="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small">
					История уведомлений
				</ListGroupItem>
		
				<ButtonToolbar>
					<Button size="sm" color="light" block onClick={getNotifications}><i className="fa fa-refresh"></i> Обновить</Button>
				</ButtonToolbar>
		
				{
					notifications.map((notification) =>
						<NotificationItem
							key={notification.recid}
							notification={notification}
							onDismiss={handleDismiss}
							onClick={() => setCurrentNotification( notification )}
						/>
					)
				}
			</ListGroup>
			
			{
				// Если выбрано сообщение, то выводим модальное окно
				!!currentNotification &&
				<NotificationModalWindow
					notification={currentNotification}
					isShow={!!currentNotification}
					close={() => setCurrentNotification(undefined)}
				/>
			}
		</>
	);
};
